module.exports = __webpack_public_path__ + "static/media/od_6 copy.feb316e2.jpg";